export type VideoContent = {
  mediaType: string;
  videoDescription: string;
  videoMetadata: string;
  videoProvider: string;
  videoTitle: string;
  videoUrl: string;
};

export type ProductGalleryAsset = {
  disabled?: boolean;
  autoPlayEnabled?: boolean;
  label?: string | null;
  path: string;
  position?: number;
  previewPath?: string;
  role?: string[];
  type?: "video" | "image";
  videoContentDto?: VideoContent | null;
};
